<template>
  <ButtonSquareNoIcon
    class="navigation-buttons__button"
    size="small"
    :character="buttonText"
    @clicked="changePitch"
  />
</template>

<script>
import { mapState } from 'vuex'
import ButtonSquareNoIcon from '@/components/general/buttons/ButtonSquareNoIcon.vue'
export default {
  name: 'PitchControl',
  components: {
    ButtonSquareNoIcon
  },
  data() {
    return {
      pitchButtonTreshold: 30 // Treshold for when the view should be considered 2D or 3D
    }
  },
  computed: {
    ...mapState({
      currentPitch: (state) => state.currentPitch
    }),
    buttonText() {
      return this.currentPitch < this.pitchButtonTreshold ? '3D' : '2D'
    }
  },
  methods: {
    changePitch() {
      const animationDuration = 1000
      const pitch = this.buttonText === '3D' ? 60 : 0
      this.$store.map.flyTo({
        pitch,
        curve: 0.5, // Lower value equals slower/smoother transition
        screenSpeed: 0.5,
        easing: function (t) {
          return t
        }, // Easing function for zoom speed
        duration: animationDuration
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-buttons__button {
  margin: 0px 0px 10px 0px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
